<body *ngIf="showOverlay" style="background-color: black; z-index: 100000;">
    <div id="loading-wrapper">
      <div id="loading-text">
        <img src="./assets/img/E-Cell Logo-White.png">
        <h2>abhaybahy</h2>
      </div>
      <div id="loading-content"></div>
    </div>
  </body>